import { createEventConstants } from '../constants';

export const createEventReducer = (state = {}, action) => {
    switch(action.type) {
        case createEventConstants.CREATE_EVENT_REQUEST:
            return {
                ...state,
                data: {...state.data, ...action.payload},
                createEventProcess: true
            }
        
        case createEventConstants.CREATE_EVENT_FAILURE:
            return {
                ...state,
                createEventProcess: false,
                createEventError: true
            }
       
        case createEventConstants.CREATE_EVENT_SUCCESS:
            return {
                ...state,
                ...action.payload,
                createEventProcess: false,
                createEventError: false
            }

        default:
            return state;
    }
}

export default createEventReducer;


// WEBPACK FOOTER //
// ./src/reducers/createEvent.js